import Controller from "@ember/controller";
import { action } from "@ember/object";
import { cached, tracked } from "@glimmer/tracking";

export default class ServerStatisticsController extends Controller {
  queryParams = ["resolution", "resource"];

  @cached
  get data() {
    return this.model.data.usage;
  }

  get server() {
    return this.model.server;
  }

  @tracked resolution;
  @tracked resource;

  resolutionOptions = Object.freeze([
    { label: "Day", value: "day" },
    { label: "Hour", value: "hour" },
    { label: "Minute", value: "minute" },
  ]);

  get resourceOptions() {
    let server = this.server;

    if (server.get("isVMware")) {
      return [
        { label: "CPU", value: "cpuusage" },
        { label: "Memory", value: "memoryusage" },
        { label: "Disk (read + write)", value: "diskioread" },
        { label: "Transfer (Total)", value: "transfertotal" },
      ];
    }
    return [];
  }

  get chartData() {
    return {
      datasets: [
        {
          data: this.data.values.map((data) => ({
            x: new Date(data.timestamp),
            y: data.value,
          })),
        },
      ],
      labels: this.data.values.map((data) => new Date(data.timestamp)),
    };
  }

  @action
  setResolution(event) {
    this.resolution = event.target.value;
  }

  @action
  setResource(event) {
    this.resource = event.target.value;
  }
}
